var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-confirm-professional-booking p-4" },
    [
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-8 offset-md-2" },
          [
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: { to: "/my-reservations" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.menu.my_reservations")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: { to: "/reservation/" + _vm.order.id }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.my_reservations.reservation_detail")
                    ) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.my_reservations.payment")) +
                "\n    "
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c("div", { staticClass: "card-body" }, [
              _vm.order.sender_type === "professional"
                ? _c(
                    "div",
                    [
                      _c("checkout-cost", {
                        attrs: { hasDivider: false },
                        on: { onChangedCostData: _vm.updateCostData }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("order-summary-total-short", {
                        attrs: { order: _vm.order }
                      })
                    ],
                    1
                  )
            ])
          ]),
          _vm._v(" "),
          _vm.costData && _vm.costData.totalPrice
            ? _c(
                "section",
                { staticClass: "pt-3" },
                [
                  _c("payment-methods", {
                    ref: "paymentMethods",
                    on: {
                      onSelectedPaymentMethod: _vm.updatePaymentMethod,
                      onSelectedCreditCard: _vm.applyUserCreditCard,
                      onRequestedSavingTempData: _vm.saveTempData,
                      onSelectedFileUpload: _vm.setFileUpload,
                      onRequestedUpdatingQrResponse: _vm.updateQrResponse,
                      onSuccessQrPayment: _vm.displaySuccessDialog
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "pt-2" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-block",
                attrs: { disabled: _vm.isLoading },
                on: {
                  click: function($event) {
                    return _vm.formValidation()
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.isLoading
                        ? _vm.$t("message.button.loading")
                        : _vm.$t("message.button.make_a_payment")
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("snackbar", {
        ref: "snackbar",
        attrs: {
          baseSize: "100px",
          colors: {
            open: "#333",
            info: "#3DBD7D",
            error: "#FA7377",
            warn: "#FF6600"
          },
          holdTime: 2500,
          position: "bottom-center"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18724b63", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18724b63","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/ConfirmProfessionalBooking.vue
// module id = 1689
// module chunks = 0